<div class="header d-flex">
  <app-competition-header class="d-flex container-fluid justify-self-center align-items-stretch" (save)="onSave()" (discard)="onDiscard()" ></app-competition-header>
</div>
<div class="container-fluid">
  <div class="row p-0 align-self-center">
    <div class="col-12 col-md-6 col-lg-4 p-0 sidebar">
      <app-competition-details [competition]="competition"></app-competition-details>
      <app-competition-logo #lgcompetition [competition]="competition" (fileError)="onFileError($event)"></app-competition-logo>
       <app-competition-background #bgcompetition [competituonUploaderType]="'background'" [competition]="competition" (fileError)="onFileError($event)"></app-competition-background>
       <app-competition-background #stcompetition [competituonUploaderType]="'stadium'"  [competition]="competition" (fileError)="onFileError($event)"></app-competition-background>
       <app-competition-background #ftcompetition [competituonUploaderType]="'footer'"  [competition]="competition" (fileError)="onFileError($event)"></app-competition-background>
    </div>

    <div class="col-12 col-md-6 col-lg-8 content">
      <app-main-navbar></app-main-navbar>

      <!-- Hero Competition -->
      <div class="mb-8 mt-5">
        <app-competition-jumbotron-manage [competition]="competition"></app-competition-jumbotron-manage>
      </div>
    </div>
  </div>
</div>
